import React, { useState } from 'react';

import ColorLensOutlinedIcon from '@mui/icons-material/ColorLensOutlined';
import { useTheme } from '@mui/material';
import { IconButton } from 'components/IconButton';

import ProfileThemePopover from './Popover';
import { StyledBannerWrap, StyledProfileBannerImage } from './style';

function Banner() {
	const [isPopoverOpen, setIsPopoverOpen] = useState<boolean>(false);
	const theme = useTheme();

	const openSettings = () => {
		setIsPopoverOpen(true);
	};

	const closeSettings = () => {
		setIsPopoverOpen(false);
	};

	return (
		<StyledBannerWrap elevation={2}>
			<IconButton onClick={openSettings} variant="contained" size="large" background="#FFFFFFB2">
				<ColorLensOutlinedIcon color="primary" />
			</IconButton>
			<StyledProfileBannerImage src={theme.palette.banner} alt="Banner" />
			<ProfileThemePopover open={isPopoverOpen} onCloseButtonClick={closeSettings} />
		</StyledBannerWrap>
	);
}

export default Banner;
